import React from "react";
import { Form, FormGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../../redux";
import { setIntuitNumber } from "../../../../../redux/reducers/TemplateMetadataFields";

type Props = {};
export const IntuitNumber: React.SFC<Props> = ({}) => {
  const { intuitNumber } = useSelector(
    (state: ReduxState) => state.TemplateMetadataFields
  );
  const dispatch = useDispatch();
  return (
    <FormGroup>
      <Form.Label>
        <strong>Intuit number</strong>
      </Form.Label>
      <Form.Control
        type="text"
        placeholder=""
        value={intuitNumber}
        onChange={(e) => dispatch(setIntuitNumber(e.target.value))}
      />
    </FormGroup>
  );
};
export default IntuitNumber;
